import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft, Plus, ShoppingCart, X } from "lucide-react";
import { supabase } from "../../supabase-client";
import Cookies from "universal-cookie";
import { registerObraConsulta } from "../../utils/analytics";

function Obrasdet() {
   const cookies = new Cookies();
   const location = useLocation();
   const [imagenAmpliada, setImagenAmpliada] = useState(null);
   const [imageMeta, setImageMeta] = useState({});
   // const [imagenIndx, SetimagenIndx] = useState(0);
   const { state } = location;
   const [obra, setObra] = useState([]);
   // const [change, setChange] = useState(false); // 👈 Remove this state
   // const [showArrowLeft, setShowArrowLeft] = useState(false);
   // const [showArrowRight, setShowArrowRight] = useState(false);

   // Modal states for image enlargement
   const [isModalOpen, setIsModalOpen] = useState(false);
   const [selectedImage, setSelectedImage] = useState(null);
   const [currentImageIndex, setCurrentImageIndex] = useState(0);

   const [input, setInput] = useState({
      cod_obra: state ? state.cod_obra : [],
   });

   const fetchObras = async () => {
      const { error, data } = await supabase
         .from("obras")
         .select(
            `
        id,titulo,descripcion,medidas,precio,
        imagenes(texto,orden,imagen_url)
        `,
         )
         .eq("id", input.cod_obra)
         .order("created_at", { ascending: true });

      if (error) {
         console.error("Error reading obra: ", error.message);
         return;
      }

      setObra(data);
      console.log("data: ", data);
      console.log("data.imagenes.length: ", data?.[0]?.imagenes?.length);

      if (data?.[0]?.id) {
         registerObraConsulta({
            obraId: data[0].id,
            obraTitulo: data[0].titulo,
            pagina: location.pathname,
         });
      }

      // 👈 Set arrow visibility without triggering re-render
      if (data[0]?.imagenes?.length > 1) {
         console.log("Setting arrows for multiple images");
         // setShowArrowRight(true);
         // setChange(!change); // 👈 Remove this line
      }
   };

   // 👈 Clean useEffect - runs only once on mount
   useEffect(() => {
      fetchObras();
   }, [input.cod_obra]); // 👈 Only depend on cod_obra changes

   // Handle image click to open modal
   const handleImageClick = (image, index) => {
      setSelectedImage(image);
      setCurrentImageIndex(index);
      setIsModalOpen(true);
      document.body.style.overflow = "hidden";
   };

   // Close modal
   const closeModal = () => {
      setIsModalOpen(false);
      setSelectedImage(null);
      document.body.style.overflow = "unset";
   };

   // Navigate through images in modal
   const navigateImage = (direction) => {
      const totalImages = obra[0].imagenes.length;
      let newIndex;

      if (direction === "next") {
         newIndex =
            currentImageIndex === totalImages - 1 ? 0 : currentImageIndex + 1;
      } else {
         newIndex =
            currentImageIndex === 0 ? totalImages - 1 : currentImageIndex - 1;
      }

      setCurrentImageIndex(newIndex);
      setSelectedImage(obra[0].imagenes[newIndex]);
   };

   // Handle keyboard navigation
   useEffect(() => {
      const handleKeyDown = (e) => {
         if (!isModalOpen) return;

         if (e.key === "Escape") {
            closeModal();
         } else if (e.key === "ArrowLeft") {
            navigateImage("prev");
         } else if (e.key === "ArrowRight") {
            navigateImage("next");
         }
      };

      document.addEventListener("keydown", handleKeyDown);
      return () => document.removeEventListener("keydown", handleKeyDown);
   }, [isModalOpen, currentImageIndex]);

   const grabarCarrito = async (id) => {
      const { error } = await supabase
         .from("obras")
         .update({
            estado: 23,
         })
         .eq("id", id);

      console.log("grabarCarrito: ", id);
      let cart = cookies.get("obra") || [];
      if (!Array.isArray(cart)) cart = [];
      if (!cart.includes(id)) cart.push(id);
      cookies.set("obra", cart, { path: "/" });
      window.dispatchEvent(new Event("cartUpdated"));
   };

   // 👈 Clean up component unmount
   useEffect(() => {
      return () => {
         document.body.style.overflow = "unset"; // Restore scroll on unmount
      };
   }, []);
   console.log("obra: ", obra);

   const getModalFrameClass = (key) => {
      const meta = imageMeta[key];
      if (!meta) {
         return "h-72 sm:h-96 md:h-full md:min-h-[30rem]";
      }

      return meta.naturalHeight > meta.naturalWidth
         ? "h-[26rem] sm:h-[34rem] md:h-full md:min-h-[40rem]"
         : "h-72 sm:h-96 md:h-full md:min-h-[28rem]";
   };

   const saveImageMeta = (key, event) => {
      const { naturalWidth, naturalHeight } = event.currentTarget;
      setImageMeta((prev) => {
         if (
            prev[key]?.naturalWidth === naturalWidth &&
            prev[key]?.naturalHeight === naturalHeight
         ) {
            return prev;
         }
         return {
            ...prev,
            [key]: { naturalWidth, naturalHeight },
         };
      });
   };

   if (obra && obra.length > 0) {
      const fotos = obra[0]?.imagenes || [];
      const fotoActiva = fotos[currentImageIndex];
      const activeKey = `${obra[0].id}-${fotoActiva}`;
      console.log("obra: ", obra);
      console.log("fotos: ", fotos);
      console.log("currentImageIndex: ", currentImageIndex);
      console.log("fotoActiva: ", fotoActiva);
      console.log("activeKey: ", activeKey);

      return (
         <>
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
               <div
                  className="max-h-[90vh] w-full max-w-4xl overflow-auto rounded-2xl bg-white shadow-2xl"
                  onClick={(e) => e.stopPropagation()}
               >
                  {/* Header */}
                  <div className="sticky top-0 z-10 flex items-center justify-between border-b border-stone-200 bg-white/95 px-4 py-3 backdrop-blur sm:px-6">
                     <h3 className="text-base font-bold text-stone-900 sm:text-lg">
                        {obra[0]?.titulo || "Detalle de obra"}
                     </h3>
                     <button
                        type="button"
                        onClick={() => window.history.back()}
                        className="inline-flex h-9 w-9 items-center justify-center rounded-full text-stone-600 hover:bg-stone-200 hover:text-stone-900 transition-colors"
                        aria-label="Cerrar"
                     >
                        <X className="h-5 w-5" />
                     </button>
                  </div>

                  {/* Body: image gallery + info */}
                  <div className="grid gap-0 md:grid-cols-2">
                     {/* Left: main image + thumbnails */}
                     <div className="flex flex-col bg-gradient-to-b from-stone-100 to-amber-50">
                        <div
                           className={`flex items-center justify-center p-4 ${getModalFrameClass(activeKey)}`}
                        >
                           {fotoActiva?.imagen_url ? (
                              <button
                                 type="button"
                                 onClick={() => setImagenAmpliada(fotoActiva)}
                                 className="h-full w-full cursor-zoom-in"
                              >
                                 <img
                                    src={fotoActiva.imagen_url}
                                    alt={
                                       fotoActiva.texto ||
                                       obra[0]?.titulo ||
                                       "Obra"
                                    }
                                    onLoad={(e) => saveImageMeta(activeKey, e)}
                                    className="h-full w-full rounded-lg object-contain object-center transition-all duration-300"
                                 />
                              </button>
                           ) : (
                              <div className="flex h-full items-center justify-center bg-gradient-to-br from-amber-100 to-orange-100 px-6 text-center text-sm font-medium text-amber-900">
                                 Imagen no disponible
                              </div>
                           )}
                        </div>
                     </div>

                     {/* Right: info */}
                     <div className="space-y-4 p-5 sm:p-6">
                        <h2 className="text-2xl font-black leading-tight text-stone-900">
                           {obra[0]?.titulo || " "}
                        </h2>
                        {obra?.descripcion !== "-" ? (
                           <p className="text-sm leading-relaxed text-stone-700 sm:text-base">
                              {obra[0]?.descripcion ||
                                 "Escultura sacra tallada en madera."}
                           </p>
                        ) : null}

                        {/* Thumbnail strip */}
                        {fotos.length > 1 && (
                           <div className="flex gap-2 overflow-x-auto px-4 pb-4 pt-2">
                              {fotos.map((foto, idx) => (
                                 <button
                                    key={idx}
                                    type="button"
                                    onClick={(e) => {
                                       e.stopPropagation();
                                       setCurrentImageIndex(idx);
                                    }}
                                    className={`flex-shrink-0 overflow-hidden rounded-lg border-2 transition-all ${
                                       idx === currentImageIndex
                                          ? "border-amber-500 shadow-md"
                                          : "border-stone-200 opacity-60 hover:opacity-100"
                                    }`}
                                 >
                                    <img
                                       src={foto.imagen_url}
                                       alt={foto.texto || `Foto ${idx + 1}`}
                                       className="h-16 w-16 object-contain object-center bg-stone-50"
                                    />
                                 </button>
                              ))}
                           </div>
                        )}

                        {/* Caption */}
                        {fotoActiva?.texto && fotoActiva.texto !== "-" && fotoActiva.texto !== obra[0]?.titulo  ? (
                           <p className="px-4 pb-3 text-center text-xs italic text-stone-500">
                              {fotoActiva.texto}
                           </p>
                        ) : null}

                        {obra[0]?.medidas && obra[0]?.medidas !== "-" ? (
                           <div style={{ display: "flex", gap: "0.5rem" }}>
                           <h3 className="text-lg sm:text-xl lg:text-1xl">
                              Medida :
                           </h3>
                           <h3 className="text-lg sm:text-xl lg:text-1xl">
                              {obra[0]?.medidas}
                           </h3>
                        </div>
                        ) : null}
                        
                        <div style={{ display: "flex", gap: "0.5rem" }}>
                           <h3 className="text-lg sm:text-xl lg:text-1xl">
                              Precio:
                           </h3>
                           <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-green-600">
                              U$S {obra[0]?.precio?.toLocaleString()}
                           </h3>
                        </div>
                        <div>
                           <div className="md:flex items-center gap-2">
                              <div className="py-2 lg:py-3">
                                 <button
                                    className="btn-purple w-full sm:w-auto px-6 py-3 text-lg hover:bg-purple-700 transition-colors"
                                    onClick={() => grabarCarrito(obra[0].id)}
                                 >
                                    <ShoppingCart className="w-3.5 h-3.5" />
                                    Reservar
                                 </button>
                              </div>

                              <div className="justify-self-center p-2 text-center">
                                 <Link
                                    to="/obras"
                                    className="btn-gray-light hover:bg-gray-300 transition-colors"
                                 >
                                    <ArrowLeft className="lucid-icons mr-2" />{" "}
                                    Volver
                                 </Link>
                              </div>
                           </div>

                           <p>
                              Si desea contactarse con el Artista para coordinar
                              una entrevista o simplemente hacerle una pregunta
                              haga click
                              <a
                                 href="/contacto"
                                 className="text-amber-600 hover:text-amber-800 font-semibold ml-1"
                              >
                                 Aqui
                              </a>
                           </p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </>
      );
   } else {
      return (
         <div className="flex justify-center items-center min-h-screen">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
            <span className="ml-4 text-lg">Cargando...</span>
         </div>
      );
   }
}

export default Obrasdet;
